/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";

import {  doctordashboardprofile06, doctordashboardprofile07, doctordashboardprofile08, doctorprofileimg, patient20, patient21 } from "../../constants/images"
import 'react-circular-progressbar/dist/styles.css';

// import PatientModal from './modal/patientModal.jsx';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { Col, Row, Text, VerticalSeparator, VImage } from '../../style/base.style';
import { Colors } from '../../style/colors';
import { useDictionary } from '../../contexts/dictionary';
import { ActionButton, ButtonStyle } from '../../components/buttons/ActionButton';
import { Notifications } from '../../components/dashboard/notifications';
import { DashboardPage } from '../../components/layout/dashboardPage';
import { Family } from '../../components/dashboard/family';
import { Appointments } from '../../components/dashboard/appointments';
import { PopupLayout } from '../../components/common/popup';
import { useContactType } from '../../contexts/ContactContext';
import { useFormHandling } from '../../hooks/formUtils';
import { RequestConfigs } from '../../api';
import { Invoices } from '../../components/dashboard/invoices';
import { useDeviceType } from '../../contexts/DeviceContext';
import { Cases, NewCasePopup } from '../../components/dashboard/cases';



export const Dashboard: React.FC = () => {

  

  const {translate} = useDictionary()
  const [isOpen,setIsOpen] = useState<boolean>(false)

  const { contact } = useContactType()

  const navigate = useNavigate();

  const openPopup = () => {
    console.log('openPopup')
    setIsOpen(true)
  }

 
  const circleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

    if(contact && contact?.Status!== 'Active') {
      navigate("/checkout")

    }

    const handleScroll = () => {
      if (circleRef.current) {
        const elementPos = circleRef.current.getBoundingClientRect().top;
        const topOfWindow = window.scrollY;
        const percent = parseFloat(circleRef.current.getAttribute('data-percent') || '0');
        const animate = circleRef.current.dataset.animate === 'true';

        if (elementPos < topOfWindow + window.innerHeight - 30 && !animate) {
          circleRef.current.dataset.animate = 'true';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger on initial load

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

const {isMobile} = useDeviceType()




  return (

    <DashboardPage title="dashboard">
      
      <NewCasePopup isOpen={isOpen} onClose={()=>{setIsOpen(false)}}/>

      <div className="col-xl-12" >

       
        <Col $gap={25}>
        
        <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' className='first-row' $gap={25}>
        
          
            <Col $width={isMobile?"100%":'60%'} $backgroundColor={Colors.whiteBackground} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $padding='10px' >

              <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' $padding='10px 5px 15px 5px'>
                <Col $width='50%' $alignItems='flex-start'>
                  <h5>{translate('notifications')}</h5>
                </Col>
                  
                
                <Col $width='50%' $alignItems='flex-end'>
                  <Link to="/dashboard/notifications">{translate('view_all')}</Link>
                </Col>
              </Row>
              <VerticalSeparator/>
              
              
              <Col $width='100%' $alignItems='flex-start'>
                
                <Notifications/>
                

                </Col>



              


            </Col>
            
            <Col $width={isMobile?"100%":'35%'} $backgroundColor={Colors.whiteBackground} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $padding='10px'>
            
              <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' $padding='10px 5px 15px 5px'>
              
                <Col $width='50%' $alignItems='flex-start'>
                  <h5>{translate('my_family')}</h5>
                </Col>
                  
                
                <Col $width='50%' $alignItems='flex-end'>
                  <Link to="/dashboard/family">{translate('view_all')}</Link>
                </Col>
              </Row>
              
              <VerticalSeparator/>
              
              <Col $width='100%' $alignItems='flex-start'>
              
                <Family minimize={true}/>
                </Col>
              </Col>
             
          </Row>
          <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' className='second-row' $gap={25}>
         

          <Col $width={isMobile?"100%":'60%'} $backgroundColor={Colors.whiteBackground} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $padding='10px' >
          
              <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' $padding='10px 5px 15px 5px'>
              
                <Col $width='50%' $alignItems='flex-start'>
                
                  <h5>{translate('cases')}</h5>
                </Col>
                  
                
                <Col $width='50%' $alignItems='flex-end'>
                  <Link to="/dashboard/cases">{translate('view_all')}</Link>
                </Col>
              </Row>
              <VerticalSeparator/>
              <Col $width='100%' $alignItems='flex-start'>
                
                <Cases minimize={true}/>
                

                </Col>
              
            </Col>
            <Col $width={isMobile?"100%":'35%'} className='first-col'>
       
           
              <div className="favourites-dashboard w-100">
              <Link to="#" onClick={()=>openPopup()}>
                <div className="book-appointment-head">
                  <h3>
                    <span>{translate('create')}</span>{translate('new_case')}
                  </h3>
                  <span className="add-icon">
                    
                      <i className="fa-solid fa-circle-plus" />
                    
                  </span>
                </div>
                </Link>
              </div>
             
            </Col>


          </Row>

          <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' className='third-row'>
            <Col $width='100%' $backgroundColor={Colors.whiteBackground} $border={`1px solid${Colors.fieldBorder}`} $borderRadius={10} $padding='10px' >
                
              <Row $alignItems='flex-start' $justifyContent='space-between' $width='100%' $padding='10px 5px 15px 5px'>
                  <Col $width='50%' $alignItems='flex-start'>
                    <h5>{translate('invoices')}</h5>
                  </Col>
                    
                  
                  <Col $width='50%' $alignItems='flex-end'>
                    <Link to="#">{translate('view_all')}</Link>
                  </Col>
                </Row>
                <VerticalSeparator/>
                  <Invoices/>
                
              </Col>
          </Row>
        </Col>
      





        
      </div>
      
    </DashboardPage>
   
  );
};

interface CreateAppointmentPopupProps {
  isOpen:boolean
  onClose:()=>void
}
const CreateAppointmentPopup = ({isOpen,onClose}:CreateAppointmentPopupProps) => {
  const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.createAppointment})
  const {contact} = useContactType()
  const {translate} = useDictionary()


 useEffect(() => {
    if(serverRes){
      if(serverRes.succeeded){
        onClose()
      }
    }
  
 }, [serverRes]);

  return (
    <PopupLayout isOpen={isOpen} onClose={onClose}>
      <Text>{translate('appointment_verify')}{" "}{contact?.Full_Name}</Text>
      <Row $width='100%' $justifyContent='center' $gap={10}>
        <ActionButton style={ButtonStyle.light} width='100px' label={translate('cancel')} onClick={onClose} />
        <ActionButton style={ButtonStyle.dark} width='100px' label={translate('confirm')} onClick={handleClick} />
      </Row>
    </PopupLayout>
  )
}



